import { useTranslation } from "react-i18next";
import { Search, Camera, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  onSearch: () => void;
  onScan: () => void;
  isSearching?: boolean;
}

export function SearchBar({ value, onChange, onSearch, onScan, isSearching = false }: SearchBarProps) {
  const { t } = useTranslation("home");
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && !isSearching) onSearch();
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-3 bg-card rounded-xl p-2 border border-border shadow-sm">
        <div className="flex items-center gap-3 flex-1 px-3">
          <Search className="w-5 h-5 text-muted-foreground" />
          <input
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder={t("search.placeholder")}
            className="search-input py-2"
            disabled={isSearching}
          />
        </div>
        <Button onClick={onSearch} className="rounded-lg px-6" disabled={isSearching || !value.trim()}>
          {isSearching ? (
            <>
              <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              {t("search.searching")}
            </>
          ) : (
            <>
              <Search className="w-4 h-4 mr-2" />
              {t("search.search")}
            </>
          )}
        </Button>
      </div>
      
      <div className="flex justify-center">
        <Button
          variant="outline"
          onClick={onScan}
          className="rounded-full px-6 bg-card"
        >
          <Camera className="w-4 h-4 mr-2" />
          {t("search.scanModel")}
        </Button>
      </div>
    </div>
  );
}
